import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';

// 页面组件（懒加载）
import { lazy } from 'react';

// const Overview = lazy(() => import('@/pages/Overview'));
const Login = lazy(() => import('@/pages/Login'));
const Register = lazy(() => import('@/pages/Register'));
const Discover = lazy(() => import('@/pages/Discover'));
const Generate = lazy(() => import('@/pages/Generate'));
const Profile = lazy(() => import('@/pages/Profile'));
const ApiKeys = lazy(() => import('@/pages/ApiKeys'));
const ApiDocs = lazy(() => import('@/pages/ApiDocs'));
const Credits = lazy(() => import('@/pages/Credits'));
const NotFound = lazy(() => import('@/pages/NotFound'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/credits" replace />,
      },
			{
        path: 'profile',
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: 'discover',
        element: <Discover />,
      },
      {
        path: 'generate',
        element: (
          <ProtectedRoute>
            <Generate />
          </ProtectedRoute>
        ),
      },
      {
        path: 'api-keys',
        element: (
          <ProtectedRoute>
            <ApiKeys />
          </ProtectedRoute>
        ),
      },
      {
        path: 'credits',
        element: (
          <ProtectedRoute>
            <Credits />
          </ProtectedRoute>
        ),
      },
			{
        path: 'api-docs',
        element: (
          <ProtectedRoute>
            <ApiDocs />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/register',
    element: <Register />,
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
]);
